// extracted by mini-css-extract-plugin
export default {"products":"GB-z","card":"HB-z","oosMessaging":"IB-z"};